module.exports = __webpack_public_path__ + "static/media/26.1f1f4f92.png";